export default "__VITE_ASSET__DAi6EbAS__"